import { toast } from 'react-toastify';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import appApi from '../../../../../api/app-api';
import globalProgramStore from '../../../../../stores/program-store';
import { ProgramType } from '../../../../../api/types/programs/program.type';
import { CourseMetadataType } from '../../../../../api/types/programs/course/course-metadata.type';

export const addStudentsToProgramOperation = async (
  branchId: number | undefined,
  programId: number | undefined,
  yearNumber: number,
  students: UserSummaryType[],
  setShowDialog: (isClose: boolean) => void,
  setLoading: (loading: boolean) => void,
  selectedCourses: CourseMetadataType[],
) => {
  try {
    if (!branchId) {
      toast.warn(`לא ניתן לאתר את השלוחה המבוקשת נסה שוב בעוד מספר רגעים`);
      throw new Error(`branchId: ${branchId} is not define`);
    }

    if (!programId || students.length === 0) {
      toast.warn(
        `לא ניתן לאתר את התוכנית ו/או הסטודנטים יש לבחור את הסטודנטים ולהמשיך`,
      );
      throw new Error(`ProgramId and studentsId must be initialize`);
    }

    const coursesIds = selectedCourses.map((item) => item.id);
    const studentsIds = students.map((studentItem) => studentItem.id);
    const uniqStudentsItems = [...new Set(studentsIds)];
    setLoading(true);
    const res = await appApi.addStudents(
      branchId,
      programId,
      uniqStudentsItems,
      yearNumber,
      coursesIds,
    );
    // Update the state
    globalProgramStore.updateProgramDetails(programId, res.data.body);

    toast.success('הפעולה התבצאה בהצלחה');
    setLoading(false);
    setShowDialog(false);
  } catch (e) {
    console.error(
      `Adding new students to the program is failed with the error: ${e}`,
    );
    toast.error('לא ניתן להשלים את הפעולה המבוקשת, נסה שוב מאוחר יותר.');
    setLoading(false);
  }
};
